/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Unmanaged_NoteInputs */



/**
* | output |
* | --- |
* | "Certificates and routing for custom domains are configured outside oneAI on this deployment. Ask your administrator to point the domain at this service." |
*
* @param {Canvas_Domain_Unmanaged_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_unmanaged_note = /** @type {((inputs?: Canvas_Domain_Unmanaged_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Unmanaged_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zertifikate und Routing für eigene Domains werden bei dieser Installation außerhalb von oneAI konfiguriert. Bitten Sie Ihre Administration, die Domain auf diesen Dienst zu leiten.")
	return /** @type {LocalizedString} */ ("Certificates and routing for custom domains are configured outside oneAI on this deployment. Ask your administrator to point the domain at this service.")
});